import React, { useState } from 'react';

// Fade-in image (fixes flicker when the browser paints partial content)
export const FadeImage = ({ src, alt = '', className = '', style, ...rest }) => {
    const [loaded, setLoaded] = useState(false);
    return (
        <img
            src={src}
            alt={alt}
            loading="lazy"
            decoding="async"
            onLoad={() => setLoaded(true)}
            className={className}
            style={{
                opacity: loaded ? 1 : 0,
                transition: 'opacity 700ms cubic-bezier(0.7,0,0.2,1)',
                backgroundColor: '#111110',
                ...style,
            }}
            {...rest}
        />
    );
};
